import { gql } from '@apollo/client';
import { ledgerAccountFragment } from './queries';

const CREATE_LEDGER_ACCOUNT = gql`
  mutation createLedger($clientId: ID!, $ledgerAccount: AccountInput!) {
    createLedgerAccount(clientId: $clientId, ledgerAccount: $ledgerAccount) {
      ...LedgerParts
    }
  }
  ${ledgerAccountFragment}
`;

const UPDATE_LEDGER_ACCOUNT = gql`
  mutation updateLedger($ledgerAccountId: ID!, $ledgerAccountInput: LedgerAccountInput!) {
    updateLedgerAccount(
      ledgerAccountId: $ledgerAccountId
      ledgerAccountInput: $ledgerAccountInput
    ) {
      ...LedgerParts
    }
  }
  ${ledgerAccountFragment}
`;

const CREATE_FINANCIAL_INSTITUTION = gql`
  mutation createFinancialInstitution(
    $institution: FinancialInstitutionRequest!
    $populateDefaults: Boolean!
    $clientId: ID!
  ) {
    createFinancialInstitution(
      institution: $institution
      populateDefaults: $populateDefaults
      clientId: $clientId
    ) {
      id
      name
      plaidInstitutionId
      isActive
    }
  }
`;

const MAP_CONNECTION_TO_ACCOUNT = gql`
  mutation mapConnectionToLedger($clientId: ID!, $connection: ConnectionInput!, $accountId: ID!) {
    mapConnectionToAccount(clientId: $clientId, connection: $connection, accountId: $accountId) {
      id
    }
  }
`;

const UNMAP_FDS_ACCOUNT_LEDGER = gql`
  mutation unmapFDSAccountLedgerMapping($accountId: ID!, $ledgerId: ID, $dryRun: Boolean!) {
    updateAccountLedgerMapping(accountId: $accountId, ledgerId: $ledgerId, dryRun: $dryRun) {
      remappedAccounts {
        accountId
        oldLedgerId
        newLedgerId
      }
    }
  }
`;

export {
  UNMAP_FDS_ACCOUNT_LEDGER,
  UPDATE_LEDGER_ACCOUNT,
  CREATE_FINANCIAL_INSTITUTION,
  MAP_CONNECTION_TO_ACCOUNT,
  CREATE_LEDGER_ACCOUNT,
};
